import readline from 'node:readline';
import { stdin } from 'node:process';

interface Key {
  ctrl: boolean;
  name: string;
  sequence: string;
  meta: boolean;
  shift: boolean;
}

type Callback = (key: Key) => void;
export class KeyWatcher {
  private actions = new Map<string, Callback>();

  private watchExitProcess() {
    return new Promise<void>((resolve) => {
      this.on('c', (key) => {
        if (key.ctrl) {
          resolve();
        }
      });
    });
  }

  on(key: string, callback: Callback) {
    this.actions.set(key, callback);
  }

  watch() {
    const rl = readline.createInterface(stdin);

    readline.emitKeypressEvents(stdin, rl);

    if (stdin.isTTY) {
      // This is required since in test we don't have a terminal and setRawMode is undefined
      stdin.setRawMode(true);
      stdin.setEncoding('utf8');
    }

    stdin.on('keypress', this.handleKeyPress);

    return {
      ctrlCPromise: this.watchExitProcess(),
    };
  }

  unwatch() {
    if (stdin.isTTY) {
      // This is required since in test we don't have a terminal and setRawMode is undefined
      stdin.setRawMode(false);
    }
    stdin.off('keypress', this.handleKeyPress);
    stdin.pause();
    this.actions.clear();
  }

  handleKeyPress = (_: string, key: Key) => {
    this.actions.get(key.name)?.(key);
  };
}
